import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'

import { CenteredContent, CenteredFlexColumn, PageWithTitle } from '../styles/Containers'
import { SecondaryButton } from '../common/Button'
import DownloadResponseButton from '../common/DownloadResponseButton'
import ActionRequiredTemplate from '../common/ActionRequiredTemplate'
import BodyText, { SmallBodyText } from '../styles/Text'
import Link from '../styles/Link'
import foiAccessMethod, { ACCESS_METHOD_TYPE } from '../../util/foiAccessMethod'

const PageContent = styled(PageWithTitle)`
  padding: 50px;
  width: 100%;
  gap: 50px;
`

// 36px for button height, 100px for padding on PageWithTitle, 50px for gap on PageWithTitle
const ConfirmationContainer = styled(CenteredContent)`
  min-height: calc(100vh - 186px);
`

function formatConfirmationTitle(label) {
  return `${label.charAt(0).toUpperCase()}${label.slice(1)} response`
}

function ResponsePackageConfirmation({ foiId, secondaryId, fileList = [], letter, accessMethod = 'PHYSICAL', accessMethodConfig }) {
  const refreshPage = () => window.location.reload(false)
  const deliveryPresentation = foiAccessMethod.getDeliveryWarningPresentation(accessMethod, accessMethodConfig)

  return (
    <PageContent>
      <div>
        <SecondaryButton onClick={refreshPage}>
          <ArrowBackIosIcon />
          Back to FOI
        </SecondaryButton>
      </div>
      <ConfirmationContainer>
        <ActionRequiredTemplate title={formatConfirmationTitle(deliveryPresentation.label)}>
          <BodyText>Thank you! Your Freedom of Information Request response has been successfully completed.</BodyText>
          <BodyText>
            <strong>Action required.</strong> The requestor has selected “<strong>{deliveryPresentation.label}</strong>”.{' '}
            {deliveryPresentation.confirmationInstruction}
          </BodyText>
          <CenteredFlexColumn gap="5px">
            <DownloadResponseButton
              requestType="foi"
              requestId={foiId}
              secondaryId={secondaryId}
              fileList={fileList}
              letter={letter}
              label="Download Response Package"
            />
          </CenteredFlexColumn>
          <SmallBodyText>
            <Link onClick={refreshPage}>View Request Details</Link>
          </SmallBodyText>
        </ActionRequiredTemplate>
      </ConfirmationContainer>
    </PageContent>
  )
}

ResponsePackageConfirmation.propTypes = {
  foiId: PropTypes.string.isRequired,
  secondaryId: PropTypes.string.isRequired,
  fileList: PropTypes.array,
  letter: PropTypes.object,
  accessMethod: PropTypes.oneOf([ACCESS_METHOD_TYPE.PHYSICAL, ACCESS_METHOD_TYPE.OTHER_PHYSICAL, ACCESS_METHOD_TYPE.OTHER_PICKUP]),
  accessMethodConfig: PropTypes.shape({
    digitalLabel: PropTypes.string,
    physicalLabel: PropTypes.string,
    otherActiveType: PropTypes.shape({
      type: PropTypes.oneOf([ACCESS_METHOD_TYPE.OTHER_DIGITAL, ACCESS_METHOD_TYPE.OTHER_PHYSICAL, ACCESS_METHOD_TYPE.OTHER_PICKUP]).isRequired,
      label: PropTypes.string.isRequired,
      pricingDetails: PropTypes.string
    })
  })
}

export default ResponsePackageConfirmation
